import React from 'react';
import UserContext from '../../context/user-context';

// Exports
// -------

export default function useUserContext() {
  return React.useContext(UserContext);
}
